var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"app-logo",attrs:{"to":{ name: 'SiteOverview' }}},[_c('span',{staticClass:"app-logo__text"},[_vm._v("银合Pilot 数字员工平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }